import axiosInstance from '../../api/axiosInstance';

export const Paymentallocation = async (payload) => {
    const response = await axiosInstance.post('/portfolio/update-allocation', payload);
    return response.data;
};

export const ContactUs = async (payload) => {
    const response = await axiosInstance.post('/contact-us', payload);
    return response.data;
};

export const UserPortfolio = async (payload) => {
    const response = await axiosInstance.get(`/portfolio/user-portfolio-details?userId=${payload}`);
    return response.data;
};